import { Card, ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import Image from 'next/image';
import React from 'react';
import { useIntl } from 'react-intl';

interface IAuthorCardAndDescription {
  name?: string | null;
  avatar?: string | null;
  description?: string | null;
}

const AuthorCardAndDescription = ({ name, avatar, description }: IAuthorCardAndDescription) => {
  const intl = useIntl();

  if (!avatar) return null;

  return (
    <Card>
      <Card.Content className="flex flex-col p-10 md:flex-row gap-4 md:gap-12">
        <div className="relative self-center w-24 h-24 shrink-0">
          <Image className="rounded-full" src={avatar} alt="" layout="fill" objectFit="cover" />
        </div>

        <Text variant={ETextStyleVariant.MediumRegular} className="text-gray-500">
          <span
            dangerouslySetInnerHTML={{
              __html:
                description ||
                (name
                  ? intl.formatMessage(
                      { defaultMessage: '{author}, Outdoorsy Author', id: 'AxvdhZ' },
                      { author: name },
                    )
                  : intl.formatMessage({ defaultMessage: 'Outdoorsy Author', id: 'FYGDF6' })),
            }}
          />
        </Text>
      </Card.Content>
    </Card>
  );
};

export default AuthorCardAndDescription;
